import { Box, Breadcrumbs, Typography, Link } from "@mui/joy";
import { ChevronRight } from "lucide-react";
import { Link as RouterLink } from "react-router-dom";

export default function Breadcrumb() {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mt: 0, px: { xs: 1, sm: 2 } }}
        >
            <Breadcrumbs separator={<ChevronRight size={18} />}>
                <Link
                    component={RouterLink}
                    to="/dashboard"
                    level="title-lg"
                    sx={{
                        fontWeight: 500,
                        textDecoration: "none",
                        color: "inherit",
                        "&:hover": { textDecoration: "underline" },
                    }}
                >
                    Home
                </Link>
                <Link
                    component={RouterLink}
                    to="/project/list"
                    level="body-md"
                    sx={{
                        fontWeight: 500,
                        textDecoration: "none",
                        color: "inherit",
                        "&:hover": { textDecoration: "underline" },
                    }}
                >
                    Projects
                </Link>
                <Typography level="body-md" sx={{ fontWeight: 500 }}>
                    Quick Create
                </Typography>
            </Breadcrumbs>
        </Box>
    );
}
